(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.DefinitionConditionsService', MxDefinitionConditionsService);
	MxDefinitionConditionsService.$inject = [
		'$q',
		'mx.internationalization',
		'mx.SolutionBuilderAgent.ConditionsBuilder.Builder',
		'mx.SolutionBuilderAgent.ConditionsBuilder.Enums',
	];
	function MxDefinitionConditionsService($q, i18n, ConditionsBuilder, ConditionsBuilderEnums) {
		var ConditionValueTypes = ConditionsBuilderEnums.ConditionValueTypes;
		var ConditionTypes = ConditionsBuilderEnums.ConditionTypes;
		var ConditionBuilderMode = ConditionsBuilderEnums.ConditionBuilderMode;
		var ConditionLogicOperators = ConditionsBuilderEnums.ConditionLogicOperators;

		var self = this;
		var i18nBuilder = i18n.get('solutionBuilderAgent.components.mx-conditions-builder');

		self.getBuilder = getBuilder;

		return self;

		function getBuilder(query, rules) {
			var config = {
				logicOperators: {
					enumeration: [
						{
							title: i18nBuilder.and,
							value: ConditionLogicOperators.AND,
						},
						{
							title: i18nBuilder.or,
							value: ConditionLogicOperators.OR,
						},
					],
				},
				valueTypes: {
					enumeration: [
						{
							title: i18nBuilder.expression,
							value: ConditionValueTypes.Expression,
						},
					],
				},
				startConditions: {
					enumeration: [],
				},
			};

			var inputRules = [],
				predefinedConditions;
			try {
				inputRules = JSON.parse(rules).map(function (rule) {
					return {
						title: (rule.Left || '') + '=' + (rule.Right || ''),
						value: rule.Id,
					};
				});
			} catch (e) {
				mx.logCatch(e);
			}

			if (Array.isArray(inputRules) && inputRules.length > 0) {
				config.valueTypes.enumeration.push({
					title: i18nBuilder.condition,
					value: ConditionValueTypes.Value,
				});
			}

			config.conditionOutput = conditionOutput;
			config.groupOutput = groupOutput;
			config.builderOutput = builderOutput;
			config.operators = [];
			config.hidePropertiesFilter = true;
			config.mode = ConditionBuilderMode.disableDifferentOperatorsInGroup;

			var enumLoader = function () {
				return $q.when(inputRules);
			};

			try {
				predefinedConditions = JSON.parse(query);
				config.predefinedConditions = inputMapping(predefinedConditions, enumLoader, (predefinedConditions || {}).Operator);
			} catch (e) {
				mx.logCatch(e);
			}

			var builder = new ConditionsBuilder(config);

			var properties = [
				{
					ValueType: ConditionValueTypes.Expression,
					ConditionType: ConditionTypes.EnumerationReference,
					EnumLoader: enumLoader,
					Title: i18nBuilder.expression,
					Value: '',
				},
			];

			if (Array.isArray(inputRules) && inputRules.length > 0) {
				properties.push({
					ValueType: ConditionValueTypes.Value,
					ConditionType: ConditionTypes.EnumerationReference,
					EnumLoader: enumLoader,
					Title: i18nBuilder.condition,
				});
			}

			builder.properties = properties;

			return $q.when(builder);
		}

		function inputMapping(groupConfig, enumLoader, operator) {
			var group = {
				Conditions: [],
				Groups: [],
				LogicOperator: getOperatorValue(operator),
			};
			if (typeof groupConfig !== 'object') {
				return group;
			}

			if (Array.isArray(groupConfig.OperandList)) {
				groupConfig.OperandList.forEach(function (operand) {
					if (operand.Operator && Array.isArray(operand.OperandList)) {
						group.Groups.push(inputMapping(operand, enumLoader, groupConfig.Operator));
					} else {
						var condition = {
							ConditionType: ConditionTypes.EnumerationReference,
							LogicOperator: getOperatorValue(groupConfig.Operator),
							EnumLoader: enumLoader,
						};
						if (operand.Expression) {
							condition.ValueType = ConditionValueTypes.Expression;
							condition.Value = operand.Expression;
						} else if (operand.MatchOperandId) {
							condition.ValueType = ConditionValueTypes.Value;
							condition.Value = operand.MatchOperandId;
						}
						group.Conditions.push(condition);
					}
				});
			}

			return group;
		}

		function getOperatorValue(operator) {
			return operator && operator.toLowerCase() === 'and' ? ConditionLogicOperators.AND : ConditionLogicOperators.OR;
		}

		function getOperatorTitle(operator) {
			return operator === ConditionLogicOperators.AND ? 'AND' : 'OR';
		}

		function itemsToQuery(accumulateQuery, item) {
			if (item.output.query.length > 0) {
				if (accumulateQuery.length > 0) {
					accumulateQuery += ' ' + getOperatorTitle(item.logicOperatorValue) + ' ';
				}
				accumulateQuery += item.output.query;
			}
			return accumulateQuery;
		}

		function builderOutput(builder) {
			return groupOutput(builder, true);
		}

		function groupOutput(group, isBuilder) {
			var query = group.groups.length ? group.groups.reduce(itemsToQuery, '') : '';
			query = group.conditions.length ? group.conditions.reduce(itemsToQuery, query) : query;

			if (query.length && !isBuilder && group.groups.length + group.conditions.length > 1) {
				query = '(' + query + ')';
			}
			var operandList = group.groups.concat(group.conditions);
			var json = {
				Operator: operandList.length ? getOperatorTitle(operandList[0].logicOperatorValue) : null,
				OperandList: operandList.length
					? operandList.map(function (operand) {
							return operand.output.json;
					  })
					: null,
			};
			return {
				query: query,
				json: isBuilder ? JSON.stringify(json) : json,
			};
		}

		function conditionOutput(condition) {
			return condition.valueTypeValue === ConditionValueTypes.Expression
				? {
						json: {
							Expression: condition.value.trim(),
						},
						query: condition.value.trim(),
				  }
				: {
						json: {
							MatchOperandId: condition.value,
						},
						query: condition.displayValue,
				  };
		}
	}
})();
